// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"84a3113d","316":"6c5c155d","711":"6f3df188","775":"a957d6b4","957":"2f4e4f73"}[chunkId] + ".chunk.js";
};